export default __webpack_public_path__ + "static/media/485.dbfdf3ad.gif";